import React from 'react'
import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import PaymentForm from '../Forms/PaymentForm'

const PUBLIC_KEY = process.env.REACT_APP_STRIPE_KEY

const stripeTestPromise = loadStripe(PUBLIC_KEY)
function StripeContainer(props) {
    return (
        <Elements stripe={stripeTestPromise}>
            <PaymentForm baseObject={props.baseObject} setBaseObject={props.setBaseObject} setAlert={props.setAlert} />
        </Elements>
    )
}

export default StripeContainer